const MaritimeMenuTab = {
	ALERTS: "Alerts",
	VESSEL_HISTORY: "History",
	VESSELS_NEARBY: "Nearby",
	FEATURES: "Features"
};
export default MaritimeMenuTab;
